// @flow
import { createAction } from 'redux-actions';

export type BrandEngageChannelState = {
  requestStatus: ?RequestStatus,
  data: Array<ContentBlob>,
};

type AddBrandEngageResponsePayload = {
  brand_catalog_id: number,
  parent_ugc_id: UgcId,
  subject_id: UgcId,
  catalog_id: UgcId,
  text: string,
  ugc_type: ResponseUgcType,
};

type AddBrandEngageDismissPayload = {
  ugc_id: UgcId,
  clientId: Id,
  observationPayload: {
    catalog_id: number,
    observation_type_code: string,
    observation_data: { comments: string },
    client_id: number,
  },
};

export const requestBrandEngageAddResponse = createAction(
  'ADD_BRAND_ENGAGE_RESPONSE_REQUEST',
  (payload: AddBrandEngageResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

export const receiveBrandEngageAddResponse = createAction(
  'ADD__BRAND_ENGAGE_RESPONSE',
  (payload: AddBrandEngageResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

type SearchPayload = {
  clientId: Id,
  channelName: string,
  brandEngageType: string,
};

export const requestBrandEngageSearchResults = createAction(
  'REQUEST_BRAND_ENGAGE_SEARCH',
  (payload: SearchPayload) => payload
);

export const receiveBrandEngageSearchResults = createAction(
  'RECEIVE_BRAND_ENGAGE_SEARCH',
  (payload: GetContentResponse) => payload,
  (_, meta: SearchPayload) => meta
);

export const requestBrandEngageDismissContent = createAction(
  'REQUEST_BRAND_ENGAGE_DISMISS',
  (payload: AddBrandEngageDismissPayload) => payload,
  (_, ugc_id) => ugc_id
);

export const receiveBrandEngageDismissContent = createAction(
  'RECEIVE_BRAND_ENGAGE_DISMISS',
  (payload: AddBrandEngageDismissPayload) => payload,
  (_, ugc_id) => ugc_id
);

export const removeDismissedItem = createAction(
  'REMOVE_BRAND_ENGAGE_DISMISSED_CONTENT',
  (payload: UgcId) => payload
);



// WEBPACK FOOTER //
// ./src/containers/brand-engage/brandEngageActions.js